<script>
  import { SvelteUIProvider } from "@svelteuidev/core";
  import { Router, Link, Route, navigate, useLocation } from "svelte-routing";
  import { onMount, tick } from "svelte";
  import InserirUsuario from "./Telas/InsercaoDados/TelaInsereDadosUsuario.svelte";
  import TelaDeCampeonatos from "./Telas/Campeonatos/TelaDeCampeonatos.svelte";
  import Menu from "./Telas/Menu/TelaMenuPrincipal.svelte";
  import TelaMenuConfig from "./Telas/Menu/TelaMenuConfig.svelte";
  import Login from "./Telas/Autenticacao/TelaLogin.svelte";
  import Nav from "./componentes_basicos/Nav.svelte";
  import Footer from "./componentes_basicos/Footer.svelte";
  import TelaExtraiDadosUsuario from "./Telas/ExtracaoDados/TelaExtraiDadosUsuario.svelte";

  import TelaDeInscricao2 from "./Telas/Campeonatos/TelaDeInscricao2.svelte";

  import MenuLateral from "./componentes_basicos/MenuLateral.svelte";

  import TelaPrePagamento from "./Telas/MercadoPago/TelaPrePagamento.svelte";
  import TelaPaginaConstrucao from "./Telas/TelaPaginaConstrucao.svelte";
  import Conexoes from "./Classes/Conexoes";
  import ArmazenaVariaveisLogin from "./Classes/ArmazenaVariaveisLogin";
  import ArmazenaPermissoesUsuario from "./Classes/ArmazenaPermissoesUsuario";
  import LoadingTela from "./componentes_basicos/LoadingTela.svelte";
  import { Button } from "@svelteuidev/core";
  import CaixaDeDialogo from "./componentes_basicos/CaixaDeDialogo.svelte";
  import Constantes from "./Classes/Constantes";
  import CadastrarTamanhoRoupa from "./Telas/CadastrosExtras/CadastrarTamanhoRoupa.svelte";
  import ExibirTamanhoCamisa from "./Telas/CadastrosExtras/ExibirTamanhoCamisa.svelte";
  import Testar from "./Telas/Testar.svelte";
  import TelaPreInscricao from "./Telas/Campeonatos/TelaPreInscricao.svelte";
  import MinhasInscricoes from "./Telas/Campeonatos/MinhasInscricoes.svelte";
  import ProtectedRoute from "./ProtectedRoute.svelte";
  import ForcaRoteamento from "./ForcaRoteamento.svelte";
  import MontarUmCampeonato from "./Telas/Campeonatos/MontarUmCampeonato.svelte";

  import Desafios from "./Componentes/Desafios/Desafio.svelte";
  import Desafio2 from "./Componentes/Desafios/Desafio_2.svelte";

  import Tabata from "./Componentes/Timers/Tabata.svelte";
  import Emom from "./Componentes/Timers/Emom.svelte";
  import Timers from "./Componentes/Timers/Timers.svelte";
  import Wodtime from "./Componentes/Timers/Wodtime.svelte";

  import BateriaRaia from "./Campenonato/BateriaRaia.svelte";
  import PreencheProvas from "./Campenonato/PreencheProvas.svelte";
  import Resultados from "./Campenonato/Resultados.svelte";
  import PRs from "./Campenonato/PRs.svelte";

  import Checkin from "./Campenonato/Checkin.svelte";

  import Wod from "./Componentes/Treinos/Wod.svelte";

  import { logado, atualizarLogado } from "./Classes/EstadoLogado";
  import {
    permissaoUsuario,
    permissaoPlataforma,
    DadosGenericos,
    DadosPaginaAnterior,
    DadosLogin,
  } from "./Classes/Stores";

  //import Relatorios from "./Componentes/Relatorios/super_relatorio.svelte";
  import MontarCampeonatos from "./Telas/Campeonatos/MontarCampeonatos.svelte";
  import TelaSucessoPagamentoCartao from "./Telas/MercadoPago/TelaSucessoPagamentoCartao.svelte";

  import Relatorios2 from "./Componentes/Relatorios2/Tabela2.svelte";
  import ExibirCupons from "./Telas/CadastrosExtras/ExibirCupons.svelte";
  import CadastrarCupons from "./Telas/CadastrosExtras/CadastrarCupons.svelte";
  import ExibirInscritos from "./Telas/CadastrosExtras/ExibirInscritos.svelte";
  import CadastrarInscritos from "./Telas/CadastrosExtras/CadastrarInscritos.svelte";
  import TelaMeuCadastro from "./Telas/Autenticacao/TelaMeuCadastro.svelte";
  import Sobre from "./Telas/Sobre.svelte";
  import InserirResultado from "./Telas/ResultadoCampeonato/InserirResultado.svelte";
  import RankingDetalhado from "./Telas/ResultadoCampeonato/RankingDetalhado.svelte";
  import RankingProvas from "./Telas/ResultadoCampeonato/RankingProvas.svelte";
  import RankingGeral from "./Telas/ResultadoCampeonato/RankingGeral.svelte";
  import ConfigurarProvas from "./Telas/ResultadoCampeonato/ConfigurarProvas.svelte";
  import ExibeListaProvas from "./Telas/ResultadoCampeonato/ExibeListaProvas.svelte";
  import TelaEmBrancoHtml from "./Telas/Campeonatos/TelaEmBrancoHTML.svelte";
  import RegistraIngresso from "./Campenonato/RegistraIngresso.svelte";

  function PegaParametro(e) {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get(e);
    return id;
  }
  let carregandoPromise;
  let clicked = false;
  let showSidebar = true; // Variável reativa para mostrar/ocultar o menu lateral

  let pagAnterior = ""; // Defina a página inicial

  let token;
  let usuario;
  let id_empresa;
  let parametros = {};
  let api = "acesso.php";
  let conexoes = new Conexoes();
  /*  let interval = setInterval(
        async () => {
           // //console.log("url ", url);
           // //console.log("logado ", Constantes.logado);
        },

        1000,
    );*/
  let carregando = true;
  function getPageFromURL() {
    const { pathname } = window.location;
    const currentPage = pathname.substring(1); // Remove a barra inicial "/"
    return currentPage;
  }

  let actualPage = getPageFromURL();

  function ChecaPaginaAnterior() {
    /*const pag = getPageFromURL();
        if (pag.includes("prepagamento")) {
            pagAnterior = "/inscricao";
        } else if (pag.includes("preinscricao")) {
            pagAnterior = "/campeonatos";
        } else if (pag.includes("inscricao")) {
            pagAnterior = "/preinscricao";
        } else {
            pagAnterior = "";
        }*/
  }

  async function VerificaLogado() {
    carregando = true;
    token = localStorage.getItem("token");
    id_empresa = localStorage.getItem("id_empresa");
    usuario = localStorage.getItem("usuario");
    //console.log("logando");
    if (!token || !usuario || !id_empresa) {
      Constantes.logado = false;
      //console.log("nao logou");
      localStorage.setItem("token", "");
      localStorage.setItem("usuario", "");
      localStorage.setItem("id_empresa", "");
      carregando = false;
      //navigate("/login");
      atualizarLogado(false);
      return;
    }

    parametros["token"] = token;
    parametros["query_code"] = "acesso_token";
    parametros["usuario"] = usuario;
    parametros["id_empresa"] = id_empresa;
    const retorno = await conexoes.conecta(api, parametros);
    //console.log("nao logou2");
    if (retorno.sucesso) {
      localStorage.setItem("token", retorno.token);

      await ArmazenaVariaveisLogin.atualizarDados(retorno);
      await ArmazenaPermissoesUsuario.atualizarDados(retorno);
      permissaoUsuario.set(retorno);
      permissaoPlataforma.set(retorno);
      DadosLogin.set(retorno);

      atualizarLogado(true);
      Constantes.logado = true;
      //console.log("armazenou");
    } else {
      localStorage.setItem("token", "");
      localStorage.setItem("usuario", "");
      localStorage.setItem("id_empresa", "");
      Constantes.logado = false;
      //console.log("armazenou2");
      atualizarLogado(false);
      // navigate("/");
    }
    carregando = false;
  }

  function updateSidebarVisibility() {
    showSidebar = window.matchMedia("(min-width: 769px)").matches;
  }

  onMount(async () => {
    carregandoPromise = await VerificaLogado();
    const interval = setInterval(() => {
      ChecaPaginaAnterior();
    }, 1000);

    window.addEventListener("resize", updateSidebarVisibility);
    updateSidebarVisibility(); // Inicializa a visibilidade da barra lateral

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", updateSidebarVisibility);
    };
  });

  function irParaPagina(pagina) {
    paginaAtual = pagina;
  }

  export let url = "";
</script>

<Nav {pagAnterior} />
{#await carregandoPromise}
  <LoadingTela isLoading={true} />
{:then}
  <Router {url}>
    <div class="layout">
      {#if showSidebar}
        <!--<MenuLateral/>-->
      {/if}
      <div class="content">
        <Route path="/inserirusuario" component={InserirUsuario} />
        <Route path="/alterausuario/:id" let:params>
          <InserirUsuario id={params.id} />
        </Route>
        <Route path="/tamanhocamisa/:id" let:params>
          <CadastrarTamanhoRoupa id={params.id} />
        </Route>
        <Route path="/usuarios" component={TelaExtraiDadosUsuario} />
        <Route path="/sobre" component={Sobre} />

        <Route
          path={Constantes.tela_minhas_incricoes}
          component={MinhasInscricoes}
        />

        <Route path="/campeonatos" component={TelaDeCampeonatos} />

        <Route path="/preinscricao">
          <TelaPreInscricao id_campeonato={PegaParametro("id")} />
        </Route>

        <Route path={Constantes.tela_minhas_incricoes}>
          <ProtectedRoute
            component={MinhasInscricoes}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_exibir_camisas}>
          <ProtectedRoute
            component={ExibirTamanhoCamisa}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_cupons}>
          <ProtectedRoute
            component={ExibirCupons}
            params={PegaParametro("id")}
          />
        </Route>
        <Route path={Constantes.tela_editar_cupons}>
          <ProtectedRoute
            component={CadastrarCupons}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_inserir_resultado}>
          <ProtectedRoute
            component={InserirResultado}
            params={PegaParametro("id")}
          />
        </Route>
        <Route path={Constantes.tela_meu_cadastro}>
          <ProtectedRoute
            component={TelaMeuCadastro}
            params={PegaParametro("id")}
          />
        </Route>
        <Route path={Constantes.tela_editar_camisas}>
          <ProtectedRoute
            component={CadastrarTamanhoRoupa}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_menu_config}>
          <ProtectedRoute
            component={TelaMenuConfig}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path="/inscricao">
          <ProtectedRoute
            component={TelaDeInscricao2}
            params={PegaParametro("id")}
          />
        </Route>
        <Route path={Constantes.tela_relatorios}>
          <ProtectedRoute
            component={Relatorios2}
            params={PegaParametro("id")}
          />
        </Route>
        <Route path="/login2">
          <ProtectedRoute component={TelaDeCampeonatos} />
        </Route>

        <Route path={Constantes.tela_pre_pagamento}>
          <ProtectedRoute
            component={TelaPrePagamento}
            params={PegaParametro("id")}
          />
        </Route>
        <Route path={Constantes.tela_montar_campeonatos}>
          <ProtectedRoute
            component={MontarCampeonatos}
            params={PegaParametro("id")}
          />
        </Route>
        <Route path={Constantes.tela_montar_um_campeonato}>
          <ProtectedRoute
            component={MontarUmCampeonato}
            params={PegaParametro("id")}
          />
        </Route>
        <Route path={Constantes.tela_inscritos}>
          <ProtectedRoute
            component={ExibirInscritos}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_exibe_inscritos}>
          <ProtectedRoute
            component={CadastrarInscritos}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_sucesso_pagamento}>
          <ProtectedRoute
            component={TelaSucessoPagamentoCartao}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_exibe_lista_provas}>
          <ProtectedRoute
            component={ExibeListaProvas}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_desafios}>
          <ProtectedRoute component={Desafios} params={PegaParametro("id")} />
        </Route>

        <Route path={Constantes.tela_desafios2}>
          <ProtectedRoute component={Desafio2} params={PegaParametro("id")} />
        </Route>

        <Route path={Constantes.tela_wod} component={Wod} />

        <Route path="/" component={TelaDeCampeonatos} />
        <Route path="/login" component={Login} />

        <Route path="*">
          <TelaDeCampeonatos />
        </Route>

        <Route path={Constantes.tela_ranking_detalhado}>
          <ProtectedRoute
            component={RankingDetalhado}
            params={PegaParametro("id")}
          />
        </Route>
        <Route path={Constantes.tela_configurar_provas}>
          <ProtectedRoute
            component={ConfigurarProvas}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_ranking_provas}>
          <ProtectedRoute
            component={RankingProvas}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_ranking_geral}>
          <ProtectedRoute
            component={RankingGeral}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_tabata} component={Tabata} />
        <Route path={Constantes.tela_emon} component={Emom} />
        <Route path={Constantes.tela_timers} component={Timers} />
        <Route path={Constantes.tela_wodtime} component={Wodtime} />

        <Route path={Constantes.tela_bateria_raia}>
          <ProtectedRoute
            component={BateriaRaia}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_checkin}>
          <ProtectedRoute component={Checkin} params={PegaParametro("id")} />
        </Route>
        <Route path={Constantes.tela_registra_ingressos}>
          <ProtectedRoute
            component={RegistraIngresso}
            params={PegaParametro("id")}
          />
        </Route>

        <Route path={Constantes.tela_prs}>
          <ProtectedRoute component={PRs} params={PegaParametro("id")} />
        </Route>
        <Route path="/preencheprovas" component={PreencheProvas} />
        <Route path="/resultados" component={Resultados} />
        <Route path="/ranking" component={TelaEmBrancoHtml} />
      </div>
    </div>
  </Router>
{/await}
<Footer />

<style>
  .layout {
    display: flex;
    flex-direction: row;
  }

  .content {
    flex-grow: 1;
  }
</style>
